import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=0fb621ac"
import script from "./CrudTable.vue?vue&type=script&lang=js"
export * from "./CrudTable.vue?vue&type=script&lang=js"
import style0 from "./CrudTable.vue?vue&type=style&index=0&id=0fb621ac&prod&lang=scss"
import style1 from "./CrudTable.vue?vue&type=style&index=1&id=0fb621ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports